export default __webpack_public_path__ + "static/media/uploader-oneTouchVerio-3.4b4024cf.png";